<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Fleet Master</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Vehicles
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                >
                  <span>&#43;</span> Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Vehicles
                    <span><i class="ic-car"></i></span>
                  </h2>
                  <p>
                    Manage your vehicle data, including details of brand, type,
                    rate and services to support your business demand.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.row -->
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div>
            <!-- Start: Filter -->
            <div class="table-header hidden">
              <div class="row">
                <div class="col-sm-6">
                  <div class="data-row --blue25">
                    <strong>{{ items.length }} Inventory Stored</strong>
                  </div>
                </div>
                <div class="col-sm-6 text-right">
                  <div class="form-group">
                    <div class="btn-group mb-15" role="group" aria-label="...">
                      <button type="button" class="btn btn-default btn-active">
                        All Type
                      </button>
                      <button type="button" class="btn btn-default">Car</button>
                      <button type="button" class="btn btn-default">Bus</button>
                      <button type="button" class="btn btn-default">
                        Motorcycle
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End: Filter -->

            <!-- Start: Content -->
            <div class="table-accordion table-vehicles table-p15">
              <table class="table table-hover table-striped table-sticky">
                <thead>
                  <tr>
                    <th>Model</th>
                    <th class="text-center">Provider(s)</th>
                    <th class="text-center">
                      Plate No.
                      <span
                        class="button-sort"
                        @click="onClickSort('plateNumber')"
                        ><i class="ic-Switch-Vertical"></i
                      ></span>
                    </th>
                    <th class="text-center">Operation(s)</th>
                    <th class="text-center">Type &amp; Class</th>
                    <th class="text-left">Source</th>
                    <th class="text-left">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td style="width: 15%">
                      <span
                        >{{ item.factoryName }} {{ item.brandName }} ({{
                          item.feature.color
                        }})</span
                      >
                      <span class="year --grey50">
                        {{ item.feature.yearManufactured }}
                        <!-- - {{ item.feature.transmission }} -->
                      </span>
                    </td>
                    <td
                      class="text-center"
                      style="width: 15%"
                      :title="printCommaBasedProviders(item.providers)"
                    >
                      {{ printProviders(item.providers) }}
                    </td>
                    <td
                      class="pos-rel text-center"
                      style="width: 15%"
                      :title="printCommaBasedOperations(item.operations)"
                    >
                      {{ item.plateNumber }}
                      <div class="row-big-menu">
                        <ul>
                          <li v-if="!item.isOwnInventory">
                            <button
                              class="btn btn-default"
                              type="button"
                              @click="viewItem(item)"
                            >
                              <span>View</span>
                            </button>
                          </li>
                          <li v-if="item.isOwnInventory && isAllowToUpdate">
                            <button
                              class="btn btn-default --blue"
                              type="button"
                              @click.prevent="updateItem(item)"
                            >
                              <span>Edit</span>
                            </button>
                          </li>
                          <li v-if="item.isOwnInventory && isAllowToDelete">
                            <button
                              class="btn btn-default sts-danger"
                              type="button"
                              @click.prevent="
                                openVehicleDeleteModal('vehicle', item.id)
                              "
                            >
                              <span>Delete</span>
                            </button>
                          </li>
                          <li v-if="isAllowToReadPool">
                            <button
                              class="btn btn-default"
                              type="button"
                              @click.prevent="viewPool(item)"
                            >
                              <span>Pool</span>
                            </button>
                          </li>
                          <li>
                            <button
                              class="btn btn-default"
                              type="button"
                              @click.prevent="viewDocument(item)"
                            >
                              <span>Document</span>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td class="text-center">
                      {{ printOperations(item.operations) }}
                    </td>
                    <td class="text-center">
                      {{ item.type }}
                      <strong class="--blue25">{{ item.className }}</strong>
                    </td>
                    <td class="text-left">{{ item.source }}</td>
                    <td class="text-left">
                      <label class="cursor-pointer d-inline-flex">
                        <input
                          type="checkbox"
                          class="control-checkbox"
                          v-model="item.isActive"
                          :disabled="!item.isOwnInventory || !isAllowToUpdate"
                          @change="changeStatus(item)"
                        />
                        <span class="pl-5 font-weight-normal v-align-middle">
                          {{ item.isActive ? "Active" : "Inactive" }}
                        </span>
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- End: Content -->
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="vehiclemodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Vehicle</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body mt-5">
                  <ul
                    class="nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"
                  >
                    <li :class="[activeTab === 'general' ? 'active' : '']">
                      <a
                        href="#vehicle-general"
                        data-toggle="tab"
                        @click="activeTab = 'general'"
                      >
                        <span class="required">General</span>
                      </a>
                    </li>
                    <li :class="[activeTab === 'provider' ? 'active' : '']">
                      <a
                        href="#vehicle-provider"
                        data-toggle="tab"
                        @click="activeTab = 'provider'"
                      >
                        <span class="required">Provider</span>
                      </a>
                    </li>
                  </ul>
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="tab-content">
                      <div
                        id="vehicle-general"
                        class="tab-pane fade"
                        :class="[activeTab === 'general' ? 'in active' : '']"
                      >
                        <div v-if="imageData && !isViewOnly">
                          <cropper
                            class="cropper-box"
                            :src="imagePreview"
                            ref="cropper"
                          />
                        </div>
                        <div
                          class="logo-provider"
                          v-if="!imageData && imagePreview"
                        >
                          <img :src="imagePreview" alt />
                        </div>
                        <div class="btn-upload-wrapper" v-if="!isViewOnly">
                          <button class="btn btn-upload">
                            <i class="ic-up"></i>
                            {{
                              model.imageUri
                                ? "Change picture"
                                : "Upload picture"
                            }}
                          </button>
                          <input
                            id="image-uploader"
                            type="file"
                            name="imageData"
                            accept="image/jpeg,image/png"
                            v-on:change="onChangeImage($event.target.files)"
                          />
                          <button
                            v-if="imageData"
                            class="btn btn-default btn-block text-center"
                            @click="resetImage()"
                          >
                            Clear
                          </button>
                        </div>
                        <div class="form-group">
                          <label class="required">Type</label>
                          <div class="d-flex">
                            <label
                              class="cursor-pointer"
                              v-for="(item, index) in types"
                              :key="index"
                              @click="model.type = item.text"
                              :class="{ 'pl-20': index > 0 }"
                            >
                              <input
                                type="radio"
                                class="control-radio"
                                :value="item.text"
                                :checked="model.type === item.text"
                                v-model="model.type"
                                :disabled="isViewOnly"
                              />
                              <span
                                class="pl-5 font-weight-normal v-align-middle"
                              >
                                {{ item.text }}
                              </span>
                            </label>
                          </div>
                          <small
                            class="form-text sts-danger"
                            v-if="isSubmitted && !$v.model.type.required"
                          >
                            Type is required
                          </small>
                        </div>
                        <div class="form-group">
                          <label class="required">Class</label>
                          <v-select
                            class="v-search-select"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.classId.$error,
                            }"
                            placeholder=""
                            label="name"
                            v-model="model.classId"
                            :options="masterClasses"
                            :clearable="true"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.id"
                            :disabled="isViewOnly"
                          >
                          </v-select>
                          <small
                            class="form-text sts-danger"
                            v-if="isSubmitted && !$v.model.classId.required"
                            >Class is required</small
                          >
                        </div>
                        <div class="form-group" v-if="model.feature">
                          <label class="required">Color</label>
                          <v-select
                            class="v-search-select"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.feature.color.$error,
                            }"
                            placeholder=""
                            label="text"
                            v-model="model.feature.color"
                            :options="colors"
                            :clearable="true"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.text"
                            :disabled="isViewOnly"
                          >
                          </v-select>
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted && !$v.model.feature.color.required
                            "
                            >Color is required</small
                          >
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <label class="required">Manufacturer</label>
                            <div class="row">
                              <div
                                :class="{
                                  'col-sm-12': isViewOnly,
                                  'col-sm-9': !isViewOnly,
                                }"
                              >
                                <div class="form-group">
                                  <v-select
                                    class="v-search-select"
                                    :class="{
                                      'field-error':
                                        isSubmitted &&
                                        $v.model.factoryId.$error,
                                    }"
                                    placeholder=""
                                    label="name"
                                    v-model="model.factoryId"
                                    :options="factories"
                                    :clearable="true"
                                    :searchable="true"
                                    :filterable="true"
                                    :reduce="(option) => option.id"
                                    :disabled="isViewOnly"
                                    @input="onChangeManufacturer()"
                                  >
                                  </v-select>
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      isSubmitted &&
                                      !$v.model.factoryId.required
                                    "
                                    >Manufacturer is required</small
                                  >
                                </div>
                              </div>
                              <div class="col-sm-3" v-if="!isViewOnly">
                                <div class="form-group">
                                  <button
                                    type="submit"
                                    class="btn btn-default"
                                    @click.prevent="onClickAddFactory()"
                                  >
                                    Add
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <label class="required">Model</label>
                            <div class="row">
                              <div
                                :class="{
                                  'col-sm-12': isViewOnly,
                                  'col-sm-9': !isViewOnly,
                                }"
                              >
                                <div class="form-group">
                                  <v-select
                                    class="v-search-select"
                                    :class="{
                                      'field-error':
                                        isSubmitted && $v.model.brandId.$error,
                                    }"
                                    placeholder=""
                                    label="name"
                                    v-model="model.brandId"
                                    :options="filteredBrands"
                                    :clearable="true"
                                    :searchable="true"
                                    :filterable="true"
                                    :reduce="(option) => option.id"
                                    :disabled="isViewOnly"
                                    @input="onChangeVehicleCommon()"
                                  >
                                  </v-select>
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      isSubmitted && !$v.model.brandId.required
                                    "
                                    >Model is required</small
                                  >
                                </div>
                              </div>
                              <div class="col-sm-3" v-if="!isViewOnly">
                                <div class="form-group">
                                  <button
                                    type="submit"
                                    class="btn btn-default"
                                    @click.prevent="onClickAddBrand()"
                                  >
                                    Add
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="form-group" v-if="model.feature">
                          <div class="--blue25">
                            <strong class="required">Transmission</strong>
                          </div>
                          <div
                            class="btn-group-radio"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.feature.transmission.$error,
                            }"
                          >
                            <label
                              class="wrap-radio"
                              v-for="(item, index) in transmissions"
                              :key="index"
                              @click="model.feature.transmission = item.text"
                            >
                              {{ item.text }}
                              <input
                                type="radio"
                                :value="item.text"
                                :checked="model.feature.transmission === item.text"
                                v-model="model.feature.transmission"
                              />
                              <span class="bullet-mark"></span>
                            </label>
                          </div>
                          <small
                            class="form-text sts-danger"
                            v-if="isSubmitted && !$v.model.feature.transmission.required"
                            >Transmission is required</small
                          >
                        </div> -->
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label class="required">Plate No.</label>
                              <input
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.plateNumber.$error,
                                }"
                                type="text"
                                autocomplete="off"
                                v-model="model.plateNumber"
                                :disabled="isViewOnly"
                                style="text-transform: uppercase"
                              />
                              <div
                                v-if="
                                  isSubmitted && $v.model.plateNumber.$error
                                "
                              >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.plateNumber.required"
                                  >Plate Number is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.plateNumber.maxLength"
                                  >Plate Number must be less than
                                  {{
                                    $v.model.plateNumber.$params.maxLength.max
                                  }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group" v-if="model.feature">
                              <label class="required">Year Manufactured</label>
                              <div v-if="!isUpdate">
                                <v-select
                                  class="v-search-select"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      $v.model.feature.yearManufactured.$error,
                                  }"
                                  placeholder=""
                                  v-model="model.feature.yearManufactured"
                                  :options="yearsManufactured"
                                  :clearable="true"
                                  :searchable="true"
                                  :filterable="true"
                                  :disabled="isViewOnly"
                                >
                                </v-select>
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    isSubmitted &&
                                    !$v.model.feature.yearManufactured.required
                                  "
                                  >Year is required</small
                                >
                              </div>
                              <div v-else>
                                <input
                                  class="form-control"
                                  type="number"
                                  v-model="model.feature.yearManufactured"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" v-if="model.feature">
                              <label class="required">Pax Capacity</label>
                              <input
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.feature.paxCapacity.$error,
                                }"
                                type="number"
                                autocomplete="off"
                                v-model="model.feature.paxCapacity"
                                :disabled="isViewOnly"
                              />
                              <small class="text-filter">Less Driver</small>
                              <div
                                v-if="
                                  isSubmitted &&
                                  $v.model.feature.paxCapacity.$error
                                "
                              >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.feature.paxCapacity.required"
                                  >Pax Capacity is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.feature.paxCapacity.minValue"
                                  >Min Pax Capacity is
                                  {{
                                    $v.model.feature.paxCapacity.$params
                                      .minValue.min
                                  }}</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.feature.paxCapacity.maxValue"
                                  >Max Pax Capacity is
                                  {{
                                    $v.model.feature.paxCapacity.$params
                                      .maxValue.max
                                  }}</small
                                >
                              </div>
                            </div>
                          </div>
                          <!-- <div class="col-sm-6">
                            <div class="form-group" v-if="model.feature">
                              <label class="required">Doors</label>
                              <input
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.feature.doors.$error,
                                }"
                                type="number"
                                autocomplete="off"
                                v-model="model.feature.doors"
                                :disabled="isViewOnly"
                              />
                              <div v-if="isSubmitted && $v.model.feature.doors.$error">
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.feature.doors.required"
                                  >Doors is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.feature.doors.minValue"
                                  >Min Doors is
                                  {{ $v.model.feature.doors.$params.minValue.min }}</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.feature.doors.maxValue"
                                  >Max Doors is
                                  {{ $v.model.feature.doors.$params.maxValue.max }}</small
                                >
                              </div>
                            </div>
                          </div> -->
                        </div>
                        <!-- <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" v-if="model.feature">
                              <label class="required">Large Baggage Capacity</label>
                              <input
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.feature.largeBaggageCapacity.$error,
                                }"
                                type="number"
                                autocomplete="off"
                                v-model="model.feature.largeBaggageCapacity"
                                :disabled="isViewOnly"
                              />
                              <div
                                v-if="
                                  isSubmitted &&
                                  $v.model.feature.largeBaggageCapacity.$error
                                "
                              >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.feature.largeBaggageCapacity.required"
                                  >Large Baggage is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.feature.largeBaggageCapacity.minValue"
                                  >Min Large Baggage is
                                  {{
                                    $v.model.feature.largeBaggageCapacity.$params.minValue
                                      .min
                                  }}</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.feature.largeBaggageCapacity.maxValue"
                                  >Max Large Baggage is
                                  {{
                                    $v.model.feature.largeBaggageCapacity.$params.maxValue
                                      .max
                                  }}</small
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group" v-if="model.feature">
                              <label class="required">Small Baggage Capacity</label>
                              <input
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.feature.smallBaggageCapacity.$error,
                                }"
                                type="number"
                                autocomplete="off"
                                v-model="model.feature.smallBaggageCapacity"
                                :disabled="isViewOnly"
                              />
                              <div
                                v-if="
                                  isSubmitted &&
                                  $v.model.feature.smallBaggageCapacity.$error
                                "
                              >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.feature.smallBaggageCapacity.required"
                                  >Small Baggage is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.feature.smallBaggageCapacity.minValue"
                                  >Min Small Baggage is
                                  {{
                                    $v.model.feature.smallBaggageCapacity.$params.minValue
                                      .min
                                  }}</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.feature.smallBaggageCapacity.maxValue"
                                  >Max Small Baggage is
                                  {{
                                    $v.model.feature.smallBaggageCapacity.$params.maxValue
                                      .max
                                  }}</small
                                >
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <div class="form-group" v-if="model.feature">
                          <label class="cursor-pointer w-max-content">
                            <input
                              type="checkbox"
                              class="control-checkbox"
                              v-model="model.feature.hasAirConditioning"
                              :disabled="isViewOnly"
                            />
                            <span
                              class="pl-5 font-weight-normal v-align-middle"
                            >
                              Air Conditioning
                            </span>
                          </label>
                        </div>
                        <div class="form-group">
                          <label class="required">Operation</label>
                          <div class="d-flex">
                            <label
                              class="cursor-pointer"
                              v-for="(item, index) in operations"
                              :key="index"
                              :class="{ 'pl-20': index > 0 }"
                            >
                              <input
                                type="checkbox"
                                class="control-checkbox"
                                :value="item.text"
                                v-model="model.operations"
                                :disabled="isViewOnly"
                              />
                              <span
                                class="pl-5 font-weight-normal v-align-middle"
                              >
                                {{ humanize(item.text) }}
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        id="vehicle-provider"
                        class="tab-pane fade"
                        :class="[activeTab === 'provider' ? 'in active' : '']"
                      >
                        <div
                          class="row"
                          v-for="(item, index) in model.modifiedProviders"
                          :key="index"
                        >
                          <div v-if="item.state !== 'Deleted'">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">Provider</label>
                                <v-select
                                  class="v-search-select"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      $v.model.modifiedProviders.$each[index]
                                        .providerId.$error,
                                  }"
                                  placeholder=""
                                  label="name"
                                  v-model="item.providerId"
                                  :options="providers"
                                  :clearable="true"
                                  :searchable="true"
                                  :filterable="true"
                                  :reduce="(option) => option.id"
                                  :disabled="isViewOnly"
                                  @input="onChangeProvider(index, item)"
                                >
                                </v-select>
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    isSubmitted &&
                                    !$v.model.modifiedProviders.$each[index]
                                      .providerId.required
                                  "
                                  >Provider is required</small
                                >
                              </div>
                            </div>
                            <!-- <div class="col-sm-6">
                              <div class="form-group">
                                <label>Policy</label>
                                <v-select
                                  class="v-search-select"
                                  placeholder=""
                                  label="title"
                                  v-model="item.policyId"
                                  :options="policies[index]"
                                  :clearable="true"
                                  :searchable="true"
                                  :filterable="true"
                                  :reduce="(option) => option.id"
                                  :disabled="isViewOnly"
                                  @input="onChangePolicy(item)"
                                >
                                </v-select>
                              </div>
                            </div> -->
                            <div class="col-sm-12">
                              <div class="form-group">
                                <button
                                  v-if="
                                    model.modifiedProviders &&
                                    model.modifiedProviders.length > 1 &&
                                    index > 0
                                  "
                                  type="button"
                                  class="btn btn-default sts-danger"
                                  @click.prevent="removeProvider(index)"
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="row"
                          v-if="providers && model.modifiedProviders"
                        >
                          <div class="col-sm-12">
                            <button
                              v-if="model.modifiedProviders"
                              type="button"
                              class="btn btn-default"
                              @click.prevent="addProvider()"
                            >
                              Add
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer" v-if="!isViewOnly">
                      <button type="submit" class="btn btn-primary">
                        {{ isUpdate ? "Save Changes" : "Save" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="deleteItem" @cancel="cancelDelete" />

    <vehicleDocumentComponent />
    <vehiclePoolComponent />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import {
  required,
  maxLength,
  maxValue,
  minValue,
} from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import vehicleDocumentComponent from "@/components/master/vehicle/VehicleDocument";
import vehiclePoolComponent from "@/components/master/vehicle/VehiclePool";
import vehicleService from "@/services/master/vehicle/vehicleService.js";
// import policyService from "@/services/master/policy/policyService.js";
import providerService from "@/services/master/provider/providerService.js";
import masterClassService from "@/services/master/class/masterClassService.js";
import masterFactoryService from "@/services/master/masterFactoryService.js";
import masterBrandService from "@/services/master/masterBrandService.js";

export default {
  components: {
    deleteModal,
    vehicleDocumentComponent,
    vehiclePoolComponent,
  },
  computed: {
    isAllowToReadPool: function () {
      return (
        this.allServices &&
        this.allServices["VehiclePool"] &&
        this.allServices["VehiclePool"].includes("Read")
      );
    },
    isAllowToRead: function () {
      return (
        this.allServices &&
        this.allServices["Vehicle"] &&
        this.allServices["Vehicle"].includes("Read")
      );
    },
    isAllowToCreate: function () {
      return (
        this.allServices &&
        this.allServices["Vehicle"] &&
        this.allServices["Vehicle"].includes("Create")
      );
    },
    isAllowToUpdate: function () {
      return (
        this.allServices &&
        this.allServices["Vehicle"] &&
        this.allServices["Vehicle"].includes("Update")
      );
    },
    isAllowToDelete: function () {
      return (
        this.allServices &&
        this.allServices["Vehicle"] &&
        this.allServices["Vehicle"].includes("Delete")
      );
    },
    filteredBrands: function () {
      return this.brands.filter((brand) => {
        return brand.vehicleFactory.id === this.selectedFactoryId;
      });
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: "",
      },
      isSubmitted: false,
      activeTab: "general",
      rentalLabel: null,
      airportLabel: null,
      allServices: null,
      isViewOnly: false,
      selectedFactoryId: null,
      deleteId: null,
      deleteOption: null,
      providers: [],
      defaultProviderIds: [],
      types: [],
      masterClasses: [],
      factories: [],
      brands: [],
      // transmissions: [],
      operations: [],
      allPolicies: [],
      policies: [],
      colors: [],
      items: [],
      yearsManufactured: [],
      model: {},
      imagePreview: null,
      imageData: null,
      isDefaultRentalRateAvailable: false,
      isDefaultAirportRateAvailable: false,
      isLoading: false,
      isUpdate: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        type: { required },
        classId: { required },
        factoryId: { required },
        brandId: { required },
        plateNumber: { required, maxLength: maxLength(20) },
        modifiedProviders: { $each: { providerId: { required } } },
        feature: {
          // transmission: { required },
          color: { required },
          yearManufactured: { required },
          // doors: { required, minValue: minValue(1), maxValue: maxValue(6) },
          paxCapacity: {
            required,
            minValue: minValue(1),
            maxValue: maxValue(100),
          },
          // largeBaggageCapacity: {
          //   required,
          //   minValue: minValue(0),
          //   maxValue: maxValue(100),
          // },
          // smallBaggageCapacity: {
          //   required,
          //   minValue: minValue(0),
          //   maxValue: maxValue(100),
          // },
        },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );
    this.rentalLabel = this.$helper.extractSetting(
      publicSettings,
      "RentalLabel",
      "Hourly"
    );
    this.airportLabel = this.$helper.extractSetting(
      publicSettings,
      "AirportLabel",
      "Airport"
    );

    const profile = await this.$store.dispatch("user/getProfile");
    this.allServices = profile.services;

    if (this.isAllowToRead) {
      await this.getAll();
      await this.getProviders();
      await this.getCommon();
      await this.getMasterClasses();
      await this.getMasterFactories();
      await this.getMasterBrands();
      // await this.getAllPolicies();
      const startYear = new Date().getFullYear();
      for (let i = 0; i < 5; i++) {
        this.yearsManufactured.push(startYear - i);
      }

      if (profile.selectors && profile.selectors["Providers"]) {
        this.defaultProviderIds = profile.selectors["Providers"].ids;
      }
    }
  },
  mounted() {
    $(this.$refs.vehiclemodal).on("hidden.bs.modal", this.closeModal);
  },
  updated() {
    // subscribe message
    this.$eventBus.$on("openVehicleDeleteModal", this.openVehicleDeleteModal);
    this.$helper.collapseMenu("fleet-master");
    this.$helper.setNavigationClass("vehicle-link");
  },
  beforeDestroy() {
    this.$eventBus.$off("openVehicleDeleteModal");
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    async onClickSort(column) {
      if (this.table.sort === column) {
        this.table.sortDir = this.table.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.table.sortDir = "asc";
      }
      this.table.sort = column;
      await this.getAll();
    },
    onChangeProvider(index, item) {
      // this.getPoliciesByProviderId(index, item.providerId);
      if (item.id === this.$helper.emptyGuid()) {
        item.state = "Created";
      } else {
        item.state = "Updated";
      }
    },
    // onChangePolicy(item) {
    //   if (item.policyId === "") {
    //     item.policyId = null;
    //   }

    //   if (item.id === this.$helper.emptyGuid()) {
    //     item.state = "Created";
    //   } else {
    //     item.state = "Updated";
    //   }
    // },
    onChangeManufacturer() {
      this.model.brandId = null;
      this.onChangeVehicleCommon();
    },
    onChangeVehicleCommon() {
      this.selectedFactoryId = this.model.factoryId;
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.vehiclemodal).modal({ backdrop: "static", keyboard: false });
    },
    closeModal() {
      const imageUploader = document.getElementById("image-uploader");
      if (imageUploader) {
        imageUploader.value = "";
      }
      this.imagePreview = null;
      this.imageData = null;
      this.model = {};
      $(this.$refs.vehiclemodal).modal("hide");
    },
    openVehicleDeleteModal(option, id) {
      this.deleteOption = option;
      this.deleteId = id;
      $("#deletemodal").modal();
    },
    onChangeImage(files) {
      const maxSize = 4 * 1024 * 1024;
      if (files[0].size > maxSize) {
        this.imagePreview = null;
        this.imageData = null;
        document.getElementById("image-uploader").value = "";
        alert(
          `File is too big, max-size is  ${parseInt(maxSize / 1000000)}MB.`
        );
        return;
      }
      if (
        !["jpeg", "jpg", "png"].includes(
          files[0].name
            .substring(files[0].name.lastIndexOf(".") + 1)
            .toLowerCase()
        )
      ) {
        this.imagePreview = null;
        this.imageData = null;
        document.getElementById("image-uploader").value = "";
        alert("Invalid file type.");
        return;
      }
      this.imagePreview = URL.createObjectURL(files[0]);
      this.imageData = files[0];
    },
    async uploadImage(id) {
      const uploader = document.getElementById("image-uploader");
      if (uploader.value && uploader.value !== "") {
        const { canvas } = this.$refs.cropper.getResult();
        if (canvas) {
          const model = {
            id: id,
          };
          const formData = new FormData();
          for (const key in model) {
            if (model.hasOwnProperty(key)) {
              formData.append(key, model[key]);
            }
          }
          const blob = await new Promise((resolve) => canvas.toBlob(resolve));
          formData.append("file", blob, this.imageData.name);
          await vehicleService.uploadImage(formData);
        }
      }
    },
    resetImage() {
      this.imageData = null;
      this.imagePreview = null;
      document.getElementById("image-uploader").value = "";
    },
    async createItem() {
      this.isViewOnly = false;
      this.isUpdate = false;
      this.policies = [];
      this.activeTab = "general";

      const modifiedProviders = [];
      if (this.defaultProviderIds && this.defaultProviderIds.length > 0) {
        for (let i = 0; i < this.defaultProviderIds.length; i++) {
          modifiedProviders.push({
            id: this.$helper.emptyGuid(),
            providerId: this.defaultProviderIds[i],
            // policyId: null,
            state: "Created",
          });
          // this.getPoliciesByProviderId(i, modifiedProviders[i].providerId);
        }
      } else {
        modifiedProviders.push({
          id: this.$helper.emptyGuid(),
          providerId: null,
          // policyId: null,
          state: "Created",
        });
      }

      // default parameters
      this.openModal({
        classId: null,
        factoryId: null,
        brandId: null,
        type: this.types[0].text,
        providers: [],
        operations: ["WithDriver", "SelfDrive"],
        modifiedProviders: modifiedProviders,
        feature: {
          color: null,
          // doors: 4,
          hasAirConditioning: true,
          // largeBaggageCapacity: 1,
          // smallBaggageCapacity: 1,
          paxCapacity: 0,
          // transmission: this.transmissions[0].text,
          yearManufactured: new Date().getFullYear(),
        },
      });
    },
    updateItem(item) {
      this.isViewOnly = false;
      this.isUpdate = true;
      this.selectedFactoryId = item.factoryId;
      this.imagePreview = item.imageUri;
      this.activeTab = "general";
      item.modifiedProviders = [];
      this.openModal(item);
      for (let i = 0; i < this.model.providers.length; i++) {
        this.model.modifiedProviders.push({
          id: this.model.providers[i].id,
          providerId: this.model.providers[i].providerId,
          // policyId: null,
          state: "NoAction",
        });
        // this.getPoliciesByProviderId(i, this.model.modifiedProviders[i].providerId);
        // this.model.modifiedProviders[i].policyId = this.model.providers[i].policyId;
      }
    },
    viewItem(item) {
      this.isViewOnly = true;
      this.isUpdate = false;
      this.imagePreview = item.imageUri;
      this.openModal(item);
    },
    async onClickAddFactory() {
      const newFactoryName = prompt("Please enter new manufacturer name:", "");
      if (newFactoryName !== null && newFactoryName !== "") {
        try {
          await masterFactoryService.create({
            name: newFactoryName,
          });
          await this.getMasterFactories();
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        } catch (error) {
          if (error.errors) {
            for (let index = 0; index < error.errors.length; index++) {
              this.$notification.error(error.errors[index], { title: "Error" });
            }
          }
        }
      }
    },
    async onClickAddBrand() {
      const newBrandName = prompt("Please enter new model name:", "");
      if (
        newBrandName !== null &&
        newBrandName !== "" &&
        this.selectedFactoryId !== null
      ) {
        try {
          await masterBrandService.create({
            factoryId: this.selectedFactoryId,
            name: newBrandName,
          });
          await this.getMasterBrands();
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        } catch (error) {
          if (error.errors) {
            for (let index = 0; index < error.errors.length; index++) {
              this.$notification.error(error.errors[index], { title: "Error" });
            }
          }
        }
      }
    },
    async getAll() {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        if (this.table.sort && this.table.sort !== "") {
          filter += `&sort=${this.table.sort}&sortDir=${this.table.sortDir}`;
        }
        const response = await vehicleService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getCommon() {
      const common = await vehicleService.getCommon();
      this.types = common.types;
      // this.transmissions = common.transmissions;
      this.operations = common.operations;
      this.colors = common.colors;
    },
    async getProviders() {
      this.providers = await providerService.getAllActive();
    },
    async getMasterClasses() {
      this.masterClasses = await masterClassService.getAllActive();
    },
    async getMasterFactories() {
      this.factories = await masterFactoryService.getAll();
    },
    async getMasterBrands() {
      this.brands = await masterBrandService.getAll();
    },
    // async getAllPolicies() {
    //   this.allPolicies = await policyService.getAllActive();
    // },
    // getPoliciesByProviderId(index, providerId) {
    //   if (this.model.modifiedProviders && this.model.modifiedProviders.length > 0) {
    //     this.model.modifiedProviders[index].policyId = null;
    //   }
    //   this.policies[index] = [];
    //   if (providerId && providerId !== "") {
    //     this.policies[index] = this.allPolicies.filter(
    //       (x) => x.providerId === providerId
    //     );
    //   }
    // },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        // this.model.feature.doors = parseInt(this.model.feature.doors);
        this.model.feature.paxCapacity = parseInt(
          this.model.feature.paxCapacity
        );
        // this.model.feature.smallBaggageCapacity = parseInt(
        //   this.model.feature.smallBaggageCapacity
        // );
        // this.model.feature.largeBaggageCapacity = parseInt(
        //   this.model.feature.largeBaggageCapacity
        // );
        this.model.feature.yearManufactured = parseInt(
          this.model.feature.yearManufactured
        );
        this.model.providers = this.model.modifiedProviders.map((x) => x);
        if (this.isUpdate) {
          await vehicleService.update(this.model);
          await this.uploadImage(this.model.id);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          const response = await vehicleService.create(this.model);
          await this.uploadImage(response.data);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }
        this.model = {};
        this.closeModal();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    cancelDelete() {
      switch (this.deleteOption) {
        case "vehiclePool":
          // publish event
          this.$eventBus.$emit("openModalVehiclePool", this.deleteId);
          break;
      }
      this.deleteId = null;
      this.deleteOption = null;
      $("#deletemodal").modal("hide");
    },
    async deleteItem() {
      try {
        this.isLoading = true;
        switch (this.deleteOption) {
          case "vehicle":
            try {
              await vehicleService.delete(this.deleteId);
              this.$notification.success("Successfully deleted.", {
                title: "Success",
              });
              await this.getAll();
            } catch (error) {
              if (error.errors) {
                for (let index = 0; index < error.errors.length; index++) {
                  this.$notification.error(error.errors[index], {
                    title: "Error",
                  });
                }
              }
            }
            break;
          case "vehiclePool":
            // publish event
            this.$eventBus.$emit("deleteVehiclePool", this.deleteId);
            break;
          case "vehicleDocument":
            // publish event
            this.$eventBus.$emit("deleteVehicleDocument", this.deleteId);
            break;
        }
        this.deleteId = null;
        this.deleteOption = null;
        $("#deletemodal").modal("hide");
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        await vehicleService.update(item);
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
        await this.getAll();
      } catch (error) {
        item.isActive = !item.isActive;
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    viewPool(item) {
      // publish event
      this.$eventBus.$emit("initializeVehiclePool", item);
    },
    viewDocument(item) {
      // publish event
      this.$eventBus.$emit("initializeVehicleDocument", item);
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
    printProviders(item) {
      return item.length === 1
        ? item[0].providerName
        : `${item.length} providers`;
    },
    printCommaBasedProviders(item) {
      return item.length > 0 ? item.map((x) => x.providerName).join(", ") : "";
    },
    printOperations(item) {
      return item.length === 1 ? this.humanize(item[0]) : "All";
    },
    printCommaBasedOperations(item) {
      return item.join(", ");
    },
    addProvider() {
      this.model.modifiedProviders.push({
        id: this.$helper.emptyGuid(),
        providerId: null,
        // policyId: null,
        state: "Created",
      });
    },
    removeProvider(index) {
      this.model.modifiedProviders[index].state = "Deleted";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/vehicle/Vehicle.vue